// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const completeTask =
	(id: string): Action<State> =>
	({ getState, setState }) => {
		const { tasks } = getState();

		if (!tasks) {
			return;
		}

		let isDirty = false;

		const modifiedTasks = tasks.items.map((task) => {
			if (task.id === id && !task.completed) {
				isDirty = true;
				return { ...task, completed: true };
			}
			return task;
		});

		if (isDirty) {
			setState({ tasks: { ...tasks, items: modifiedTasks } });
		}
	};
